module.exports = __webpack_public_path__ + "static/img/qys_c.3a181b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/qys_c.png
// module id = lOs5
// module chunks = 16